class GiniScanAndPayPlugin {
    constructor(element) {
        this.el = element;
        this.options = {
            selectorCopy: '.gini-scan-and-pay__copy-button',
            selectorContent: '.gini-scan-and-pay__payment-details',
            selectorSuccess: '.gini-scan-and-pay__payment-success',
            selectorShowQrCode: '.gini-scan-and-pay__show-qr-code',
            popoverDuration: 3000,
            paymentStatusRefreshInterval: 5000
        };

        this.init();
    }

    init() {
        this.initCopyButtons();
        this.initShowQrCodeButton();
        this.initPaymentStatus();
    }

    initCopyButtons() {
        const copyButtons = this.el.querySelectorAll(this.options.selectorCopy);

        copyButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.copyToClipboard(button);
            });
        });
    }

    copyToClipboard(button) {
        navigator.clipboard.writeText(button.dataset.value)
            .then(() => {
                this.showTooltip(button);

                setTimeout(() => {
                    this.hideTooltip(button);
                }, this.options.popoverDuration);

            });
    }

    initShowQrCodeButton() {
        const buttons = this.el.querySelectorAll(this.options.selectorShowQrCode);
        buttons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggleContent();
            });
        });
    }

    showTooltip(button) {
        const tooltip = document.createElement('div');
        tooltip.className = 'gini-scan-and-pay__tooltip';
        tooltip.innerText = button.dataset.tooltip;
        button.parentElement.appendChild(tooltip);

        tooltip.style.left = `${button.offsetLeft + button.offsetWidth / 2 - tooltip.offsetWidth / 2}px`;
        tooltip.style.top = `${button.offsetTop - tooltip.offsetHeight - 8}px`;
        tooltip.style.position = 'absolute';
        tooltip.style.zIndex = 1000;
        button.classList.add('gini-scan-and-pay__tooltip-parent');
    }

    hideTooltip(button) {
        const parent = button.parentElement;
        const tooltip = parent.querySelector('.gini-scan-and-pay__tooltip');
        if (tooltip) {
            tooltip.remove();
        }
        button.classList.remove('gini-scan-and-pay__tooltip-parent');
    }

    toggleContent() {
        this.el.querySelectorAll(this.options.selectorSuccess).forEach(elem => {
            elem.classList.toggle('gini-scan-and-pay__d-none');
        });
        this.el.querySelectorAll(this.options.selectorContent).forEach(elem => {
            elem.classList.toggle('gini-scan-and-pay__d-none');
        });
    }

    initPaymentStatus() {
        if (this.el.dataset.ginigScanAndPayPaymentStatus !== 'paid') {
            const paymentRequestId = this.el.dataset.giniScanAndPayPaymentRequestId;

            this.paymentStatusInterval = setInterval(() => {
                this.updatePaymentStatus(paymentRequestId);
            }, this.options.paymentStatusRefreshInterval);
        }
    }

    updatePaymentStatus(paymentRequestId) {
        fetch('/wp-json/gini-scan-and-pay/v1/refresh-payment-status', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({'paymentRequestId': paymentRequestId})
        })
            .then(response => response.json())
            .then(data => {
                const status = data.status;
                if (status === 'paid' || status === 'paid_adjusted') {
                    this.toggleContent();
                    clearInterval(this.paymentStatusInterval);
                }
            })
            .catch(() => {
                clearInterval(this.paymentStatusInterval);
            });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-gini-scan-and-pay]').forEach(el => {
        new GiniScanAndPayPlugin(el);
    });
});
